<template>
  <div id="app">
    <m-header></m-header>
    <div class="main">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <m-footer></m-footer>
    <p-review></p-review>
  </div>
</template>

<script>
import MFooter from 'components/pc/footer/footer'
import MHeader from 'components/pc/header/header'
import PReview from 'base/preview/preview'
export default {
  // name: 'App',
  components: {
    MFooter,
    MHeader,
    PReview
  }
  // mounted () {
  //   window.addEventListener('resize', () => {
  //     if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
  //       window.location = 'http://10.0.0.78:8081'
  //     }
  //   })
  // }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.main
  min-width: 1400px
  padding-top: 80px
</style>



// WEBPACK FOOTER //
// src/components/pc/pIndex/pIndex.vue